import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './LogIn/AuthContext'; 
import UserSelect from '../Class/UserNameList';
import AppStrings from '../config/appstring';
import DbListSelect from '../Class/DbList';

function LoginForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ USERNAME: '', password: '',DBNAME:'' });
  const [error, setError] = useState('');

  const users = {
    USERNAME: ['SCISM', 'KEERTHANAN', 'AJITH']
  };

  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    const { USERNAME, password,DBNAME } = formData;

    if (!USERNAME || !password) {
      setError('Both fields are required.');
      return;
    }

    const mockToken = 'mock-token';
    localStorage.setItem('authToken', mockToken);

//console.log(USERNAME);
     const payload = {
     
       USERNAME:USERNAME,PASSWORD:password,DBNAME:DBNAME
      
    };

    try {
      const res = await fetch(AppStrings.UserCheck, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      
      // alert(result.message || "Data saved successfully!");
      if(result.success=="200")
      {
        
      //  console.log(result.data[0].ADMIN,'..............');

        login({ name: USERNAME,admin:result.data[0].ADMIN }); // Store user object in context
        localStorage.setItem('selectedDB', DBNAME); // ✅ Store DBNAME
        console.log(localStorage.getItem('selectedDB'),'zzzzzzzzzzzzzzzsssssssssssssss')
    setFormData({ USERNAME: '', password: '' });
    setError('');
    navigate('/Dashboard');
}
  else{
  //setError('InValud UserName Password');
  alert("User Name Or Password Worng..!");
      return;
  }
     
    } catch (err) {
      console.error("Error:", err);
      alert("Failed To Login.");
    }


   
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',  
    background: 'linear-gradient(to right, #BBEBFC, #FFC0CB)' }}>
      <div style={{ padding: '2rem', background: '#fff', borderRadius: '8px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '400px' }}>
        <h2 style={{ textAlign: 'center' }}>Login</h2>

        {/* User avatar circles */}
        {/* <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
          {users.USERNAME.map((user) => (
            <div
              key={user}
              onClick={() => setFormData({ ...formData, username: user })}
              title={user}
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: '#007BFF',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: '18px',
                margin: '0 10px',
                cursor: 'pointer',
              }}
            >
              {user[0]}
            </div>
          ))}
        </div> */}

        <form onSubmit={handleSubmit}>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <div style={{ marginBottom: '1rem' }}>
            <label>Username:</label>
            <UserSelect
        value={formData.USERNAME || ''}
        onChange={(e) => handleFormChange({ target: { name: 'USERNAME', value: e.target.value } })}
        style={{ height: '40px' }}
      />
          </div>

 {/* <div style={{ marginBottom: '1rem' }}>
            <label>Username:</label>
            <DbListSelect
        value={formData.DBNAME || ''}
        onChange={(e) => handleFormChange({ target: { name: 'DBNAME', value: e.target.value } })}
        style={{ height: '40px' }}
      />
          </div>
           */}

          <div style={{ marginBottom: '1rem' }}>
            <label>Password:</label>
            
            {/* <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{ width: '100%', padding: '8px', marginTop: '4px' }}
            /> */}
             <div class="coolinput">
    <input type="password" placeholder="" name="password" value={formData.password}
    onChange={handleChange}  autoComplete="off" class="input"/>
</div>
          </div>

          <button
            type="submit"
            style={{
             right:'100%',
              padding: '10px',
              backgroundColor: '#007BFF',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
